export const ChartSeries = {
    colors: ['#003050', '#D04000', '#70B0C0', '#204840', '#505860', '#005058', '#003050']
};
